<template>
  <div :class="['dropdown', { 'is-active': showMenu }]" @mouseleave="mouseOut">
    <div class="dropdown-trigger">
      <button
          :class="['button button-dropdown', { 'is-fullwidth': isFullWidth }, btnMinWidth]"
          aria-haspopup="true"
          aria-controls="dropdown-menu"
          @click.prevent="toggleMenu">
                <span id="dropDownPlaceholder" :class="['is-size-7', { 'has-text-weight-bold': boldSelectedText }]"
                      v-text="placeHolderCopy"
                      :ref="`selected_${dropdownName}`"></span>
        <i class="fas fa-angle-down" aria-hidden="true"></i>
      </button>
    </div>
    <div class="dropdown-menu padding-top-0" role="menu">
      <div class="dropdown-content is-marginless is-paddingless">
        <div v-for="item in items"
             class="columns is-mobile is-paddingless is-marginless border-bottom-dbdbdb">
          <div :class="['column is-paddingless', { 'is-marginless': noMarginLabels}]">
            <label class="checkbox is-size-6 label-filters">
              <input type="checkbox"
                     :value="item.value"
                     :checked="checkedItems.includes(parseInt(item.value))"
                     ref="inputs"
                     @change="onChangeFilter(`${dropdownName}`, $event)"
                     name="inputs"
              >&nbsp;&nbsp;&nbsp;{{item.name}}

            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    /* eslint-disable indent,no-new,no-undef */
    import _ from 'lodash'

    export default {
        name: 'MultipleSelectionDropDown',
        props: {
            btnMinWidth: {
                type: String,
                default: 'button-width-50px'
            },
            placeHolder: {
                type: String,
                default: 'Placeholder...'
            },
            dropdownName: {
                type: String,
                default: 'group_name'
            },
            dropdown_label: {
                type: String,
                default: 'Label'
            },
            checkedItems: {
                type: Array,
                default: () => {
                    return [{
                        name: 'Example name',
                        value: 'example_value'
                    }]
                }
            },
            items: {
                type: Array,
                default: () => {
                    return [{
                        name: 'Example name',
                        value: 'example_value'
                    }]
                }
            },
            selectFirstItemOnMount: {
                type: Boolean,
                default: false
            },
            selectAllItemOnMount: {
                type: Boolean,
                default: false
            },
            isFullWidth: {
                type: Boolean,
                default: false
            },
            noMarginLabels: {
                type: Boolean,
                default: false
            },
            boldSelectedText: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                showMenuList: false,
                placeHolderText: '',
                selected_collection: [],
                no_of_selected_filters: 0,
                checkedValues: []
            }
        },
        created () {
            window.events.$on('reset-filters', this.resetFilters)
        },
        /**
         * Trigger click event for first item when component is mounted
         * @returns {void}
         */
        mounted () {
            if (this.selectFirstItemOnMount) {
                const refKey = this.items[0].value
                this.$refs[refKey][0].click()
                this.toggleMenu()
            }

            if (this.selectAllItemOnMount) {
                let items = this.items
                for (let item in items) {
                    this.selected_collection.push(items[item].value)
                }
                this.no_of_selected_filters = items.length
            }
            if (this.checkedItems) {
                var tags = document.getElementsByName('inputs')
                for (var i = 0; i < tags.length; ++i) {
                    for (let j = 0; j < this.checkedItems.length; j++) {
                        if (tags[i].value === this.checkedItems[j]) {
                            tags[i].checked = true
                        }
                    }
                }
                for (let i = 0; i < this.checkedItems.length; i++) {
                    this.selected_collection.push(this.checkedItems[i])
                }
                this.no_of_selected_filters = this.checkedItems.length
            }
        },
        computed: {
            showMenu () {
                return this.showMenuList
            },
            placeHolderCopy () {
                if (this.placeHolderText.length === 0) {
                    return this.placeHolder
                }

                return this.placeHolderText
            }
        },
        methods: {
            resetFilters () {
                this.selected_collection = []
                this.no_of_selected_filters = 0
                this.$refs.inputs.forEach((element) => {
                    element.checked = false
                })
            },
            onItemSelected (label, event) {
                this.$emit('changed', {
                    name: label,
                    value: event.target.value
                })
                this.placeHolderText = label
                this.toggleMenu()
            },
            onChangeFilter (filter, event) {
                let isChecked = event.target.checked
                let value = event.target.value
                let index = this.selected_collection.indexOf(value)
                if (isChecked) {
                    this.selected_collection.push(value)
                    this.no_of_selected_filters++
                } else {
                    this.selected_collection.splice(index, 1)
                    this.no_of_selected_filters--
                }
                if (this.selected_collection.length === 1) {
                    let parent = this
                    this.items.forEach((item) => {
                        let found = false
                        if (!found) {
                            if (item.value === parent.selected_collection[0]) {
                                found = true
                                this.$refs['selected_' + filter].innerHTML = item.name
                            }
                        }
                    })
                    this.$emit('multiple-dropdown-changed', {
                        name: filter,
                        value: parent.selected_collection
                    })
                }
                if (this.selected_collection.length > 1) {
                    this.$refs['selected_' + filter].innerHTML = 'Multiple selections'
                    this.$emit('multiple-dropdown-changed', {
                        name: filter,
                        value: this.selected_collection
                    })
                }
                if (this.selected_collection.length === 0) {
                    this.$refs['selected_' + filter].innerHTML = 'Select...'
                    this.$emit('multiple-dropdown-changed', {
                        name: filter,
                        value: this.selected_collection
                    })
                }
                // Check and create array for selected val and emit event accordingly
                if (event.target.checked && this.checkedValues.indexOf(parseInt(event.target.value))) {
                  this.checkedValues.push(parseInt(event.target.value))
                } else {
                  this.$delete(this.checkedValues, this.checkedValues.indexOf(parseInt(event.target.value)))
                }
                switch (this.checkedValues.length) {
                  case 1 :
                    let availableVal = this.checkedValues[0]
                    let data = _.find(this.items, (voteItem) => { return parseInt(voteItem.value) === parseInt(availableVal) })
                    let index = _.indexOf(this.items, data)
                    this.$refs['selected_' + filter].innerHTML = this.items[index].name
                    break
                  case 2 :
                  case 3 :
                    this.$refs['selected_' + filter].innerHTML = 'Multiple selections'
                    break
                  default :
                    this.$refs['selected_' + filter].innerHTML = this.placeHolder
                }
                this.$emit('checkbox-values', this.checkedValues)
            },
            toggleMenu () {
                this.showMenuList = !this.showMenuList
            },
            mouseOut () {
                this.showMenuList = false
            }
        }
    }
</script>
<style scoped>
  .tabs.is-toggle a {
    border-radius: 0;
    border: 0;
    padding: 10px 10px 11px 4px;
  }

  .tabs-open {
    padding: 10px 10px 24px 4px !important;
  }

  .tabs.is-boxed {
    background-color: #f5f5f5;
    border: 0 !important;
  }

  .search-filter-cont {
    background-color: #f5f5f5;
  }

  @media screen and (max-width: 767px) {
    .search-filter-cont {
      margin-top: 32px;
    }
  }

  .fa-filter {
    font-size: 1.2em;
  }

  label {
    color: #8a8c91;
    padding: .9em;
  }

  .fa-angle-down:before {
    border: 1px solid #95979b;
    border-right: 0;
    border-top: 0;
    content: " ";
    display: block;
    height: 0.5em;
    pointer-events: none;
    position: absolute;
    transform: rotate(-45deg);
    transform-origin: center;
    width: 0.5em;
    margin-top: -0.375em;
    right: 1.125em;
    top: 50%;
    z-index: 4;
  }

  .dropdown-trigger {
    text-align: left;
    width: 100%;
  }

  .dropdown {
    width: 100%;
  }

  .button-filter {
    padding-left: 1.5em;
    padding-right: 1.5em;
  }

  .fa-angle-down {
    font-size: 1.4rem;
  }

  .fa-angle-down:before {
    right: 0.7em;
  }

  .label-filters {
    color: #58595b;
  }

  .dropdown-menu {
    border-top: 3px solid #30AAE1;
    width: 100%;
  }

  .dropdown-content {
    border-radius: 0;
  }

  .border-bottom-dbdbdb {
    border-bottom: 1px solid #dbdbdb;
  }

  .is-size-6 {
    font-size: 0.9rem !important;
  }

  input[type="radio"] {
    width: 16px;
    height: 16px;
  }

  label.checkbox, label.radio {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/MultipleSelectionDropDown.vue